var m = require('mithril');
var formGroup = require('../formGroup');

var component = {};

component.view = function view (vnode) {
  return m(formGroup, [
    m('label', {for: (vnode.attrs.field.id || 'text') + '-input'}, vnode.attrs.field.name),
    m('textarea.form-control.h5', {
      id: (vnode.attrs.field.id || 'text') + '-input',
      oninput: function(ev){vnode.attrs.prop(ev.target.value)},
      value: vnode.attrs.prop(),
    })
  ]);
};

module.exports = component;
